import React, { useEffect, useState, useRef } from 'react';
import { debounce } from 'lodash';
import {
    DataGrid,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    useGridSelector
} from '@mui/x-data-grid';
import { useNavigate, useLocation, Link, useParams } from 'react-router-dom';
import axios from 'axios';
import {
    Box,
    Grid,
    CircularProgress,
    Paper,
    Divider,
    Tooltip,
    useMediaQuery,
    Typography,
    TablePaginationProps,
} from '@mui/material';
import MuiPagination from '@mui/material/Pagination';
import { styled } from '@mui/material/styles';
import {
    getCounselorsListManagerScholarshipsURL,
    getCounselorOrganizationsBrandingURL,
    getNonProfitOrganizationLogoURL,
    getCounselorOrganizationDetailsURL,
    getLoggersURL
} from '../../../../../services/api/endpoints';
import oneClickApplySvg from '../../../../../assets/images/oneClickApplySvg.svg';
import { SearchOption } from '../../../../StudentViewedPage/Components/SearchBar/index';
import OrangeCard from '../../../../../assets/images/ScholarshipPage/Solid_orange.svg';
import CustomNoRowsOverlay from '../../../../../Components/DataGrid/NoRowsOverlay/index';
import ScholarshipPage from '../../../../../Layout/ScholarpageFooter/index';
import { AMAZON_S3_BASE_URL } from '../../../../../services/api/config';
import DashboardSchoarshipCard from '../../../../../Components/common/DashboardSchoarshipCard.tsx';

import {
    HEADER_TEXT_TRANSFORM,
    TABLE_FOOTER_HEIGHT,
    TABLE_FOOTER_HEIGHT_SMALL,
    TABLE_HEADER_HEIGHT,
    TABLE_PAGINATION_MARGIN,
} from '../../../../../constants/layout.ts';
import { COLOR_SECONDARY, COLOR_TEXT, COLOR_WHITE, isColor } from '../../../../../constants/color.ts';
import HelmetHeader from '../../../../../HelmetHeader.tsx';
import { HeaderText } from '../../../../../Components/Account/CommonStyledComponents/componentHeaderText.ts';
import { CustomActionButton } from '../../../../../Components/MuiComponentsOverriden/ActionButton/index.tsx';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';



const hexToRgb = (hex) => {
    // Remove '#' if present
    hex = hex.replace('#', '');

    // Parse hexadecimal color code
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return [r, g, b];
};
const lightenColor = (color) => {
    // Convert hex to RGB
    const [r, g, b] = hexToRgb(color);

    // Lighten RGB color
    const lightenFactor = 0.8; // Increase this value to make the color lighter
    const newR = Math.min(255, Math.floor(r * (1 + lightenFactor)));
    const newG = Math.min(255, Math.floor(g * (1 + lightenFactor)));
    const newB = Math.min(255, Math.floor(b * (1 + lightenFactor)));

    // Convert RGB to hex
    const rgbToHex = (r, g, b) => '#' + [r, g, b].map((val) => val.toString(16).padStart(2, '0')).join('');
    return rgbToHex(newR, newG, newB);
};

const CssDataGrid = styled(DataGrid)(({ organizationBrandingDetails }) => {
    const orgColor = organizationBrandingDetails?.customBranding ? organizationBrandingDetails?.navBackgroundColor : '#000000';
    const color = isColor(orgColor) ? orgColor : "#000000";
    const lighterColor = lightenColor(color); // First lighter shade

    return {
        '& .css-levciy-MuiTablePagination-displayedRows': {
            color: color,
            fontWeight: 500,
            // Add any other styles here
        },
        '& .css-w54qha-MuiButtonBase-root-MuiIconButton-root': {
            color: color,
        },
        '& .css-w54qha-MuiButtonBase-root-MuiIconButton-root.Mui-disabled': {
            color: lighterColor,
        },
        '&.css-i4bv87-MuiSvgIcon-root': {
            backgroundColor: lighterColor
        }
    };
});

const EmbeddedScholarhips = () => {
    const isProduction = process.env.NODE_ENV === 'production';
    const { organizationIdOrName } = useParams();
    const isId = /^\d+$/.test(organizationIdOrName ? organizationIdOrName : '');
    const [queryingParameter, setQueryingParameter] = useState<string | number>(organizationIdOrName ? organizationIdOrName : '');

    const windowWidth = useRef(window.innerWidth);
    const currentWindowWidth = windowWidth.current;
    const navigate = useNavigate();
    // const auth_token = useSelector((state: any) => state.login.loginDetails.data.auth_token);
    const [scholarshipsListData, setScholarshipsListData] = useState<any | null>(null);
    const [paginationModel, setPaginationModel] = useState<any>({
        page: 0,
        pageSize: 10,
    });
    const [totalRecordCount, setTotalRecordCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [rowCountState, setRowCountState] = useState(totalRecordCount || 0);
    const [searchText, setSearchText] = useState<string | null>('');
    const [searchTextFinal, setSearchTextFinal] = useState<string | null>('');
    const [organizationBrandingDetails, setOrganizationBrandingDetails] = useState<any | null>(null);
    const [organizationDetails, setOrganizationDetails] = useState<any | null>(null);
    const [organizationLogoUrl, setOrganizationLogoUrl] = useState<string | null>(null);
    const [favIconUrl, setFavIconUrl] = useState<string | null>(null);
    const [firstLetterCapCasedName, setFirstLetterCapCasedName] = useState<string>('');
    const [firstLetterCappedName, setFirstLetterCappedName] = useState<string>('');
    const [totalWidth, setTotalWidth] = useState(0.79 * currentWindowWidth);
    const [isHovered, setIsHovered] = useState<boolean>(false);
    const [hoveredId, setHoveredId] = useState<number | null>(null);
    const [rerenderAfterScholarshipDelete, setRerenderAfterScholarshipDelete] = useState<boolean | null>(null);
    const [dashedNameAddress, setDashedNameAddress] = useState<string | null>(null);
    const [organizationId, setOrganizationId] = useState<number | null>(isId ? organizationIdOrName : null);

    // Section to handle redirections to  OrgName in url if id is entered

    useEffect(() => {
        if (isId && dashedNameAddress) {
            setQueryingParameter(dashedNameAddress);
            navigate(`/schools/${dashedNameAddress}/scholarships`)
        }
    }, [dashedNameAddress]);

    useEffect(() => {
        setRowCountState((prevRowCountState) => (totalRecordCount ? totalRecordCount : prevRowCountState));
    }, [totalRecordCount]);

    const [sortingOrder, setSortingOrder] = useState({
        column: 'title',
        order: 'asc',
    });

    const handleSearchTextChange = (e) => {
        const inputText = e.target.value;
        setSearchText(inputText);
    };

    const handleSearch = (search_query: string) => {
        setSearchTextFinal(searchText);
    };
    const handleColumnHeaderClick = (field: any) => {
        if (field.field !== 'requirements') {
            setSortingOrder((prevSorting) => ({
                column: field.field,
                order: prevSorting.column === field.field ? (prevSorting.order === 'asc' ? 'desc' : 'asc') : 'asc',
            }));
        }
    };

    const handleMouseEnter = (scholarshipId: number) => {
        setIsHovered(true);
        setHoveredId(scholarshipId);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        setHoveredId(null);
    };

    useEffect(() => {
        const fetchEmbeddedScholarshipsListData = async () => {
            setIsLoading(true);
            try {
                let paramsBody;
                if (isId) {
                    paramsBody = {
                        page_index: paginationModel.page + 1,
                        page_size: paginationModel.pageSize,
                        sort_by: sortingOrder.column,
                        order: sortingOrder.order,
                        search_query: searchTextFinal,
                        organizationId: queryingParameter
                    }
                }
                else {
                    paramsBody =
                    {
                        page_index: paginationModel.page + 1,
                        page_size: paginationModel.pageSize,
                        sort_by: sortingOrder.column,
                        order: sortingOrder.order,
                        search_query: searchTextFinal,
                        dashedOrganizationName: queryingParameter
                    }
                }
                const res = await axios.get(`${getCounselorsListManagerScholarshipsURL}`, {
                    headers: {},
                    params: paramsBody,
                });
                if (res && res.data.code === 200) {
                    const responseData = res.data.data.records;
                    setTotalRecordCount(res.data.data.totalRecordCount);
                    setRowCountState(res.data.data.totalRecordCount);
                    if (responseData !== null) {
                        const mappedScholarships = responseData.map(
                            (
                                item: {
                                    status: any;
                                    applyable: boolean | null;
                                    title: string;
                                    id: number;
                                    url: string;
                                    deadline: any;
                                    amount: number;
                                    createdAt: any;
                                    gpaRequirementLowerBound: number | null;
                                    gpaRequirementUpperBound: number | null;
                                    ageRequirementLowerBound: number | null;
                                    ageRequirementUpperBound: number | null;
                                    essayRequired: boolean | null;
                                    additionalRequirements: string;
                                    usCitizenshipRequired: boolean | null;
                                    essayRequirements: boolean | null;
                                    letterofrecommendationRequired: boolean | null;
                                    transcriptsRequired: boolean | null;
                                    additionalapplicationpaperworkRequired: boolean | null;
                                    renewable: boolean | null;
                                    trust: number;
                                    competition: number;
                                    verified: boolean | null;
                                    hasMoreQualifications: boolean | null;
                                    hasSchoolAttendingRequirements: boolean | null;
                                    moreQualifications: any;
                                    moreRequirements: any;
                                    hasMoreRequirements: any;
                                    requiredGenders: any;
                                    requiredEthnicities: any;
                                    requiredOrganizations: any;
                                    scholarshipId: number;
                                },
                                index: number
                            ) => {
                                const requirementsArray = [
                                    { name: 'Paper App', value: item.additionalapplicationpaperworkRequired },
                                    { name: 'Essay', value: item.essayRequirements },
                                    { name: 'Rec. Letter', value: item.letterofrecommendationRequired },
                                    { name: 'US Citizenship', value: item.usCitizenshipRequired },
                                    { name: 'Transcripts', value: item.transcriptsRequired },
                                ];

                                const moreDetailsArray = [
                                    { name: 'More-Q-Details', value: item.hasMoreQualifications },
                                    { name: 'More-R-Details', value: item.hasMoreRequirements },
                                ];

                                const scholarshipObject = {
                                    rowIndex: index + 1,
                                    id: item.id,
                                    title: item.title || null,
                                    applyable: item.applyable,
                                    amount: item.amount || 0,
                                    deadline: item.deadline,
                                    requirements: requirementsArray,
                                    moreDetails: moreDetailsArray,
                                    hasMoreQualifications: item.hasMoreQualifications,
                                    moreQualifications: item.moreQualifications,
                                    hasMoreRequirements: item.hasMoreRequirements,
                                    moreRequirements: item.moreRequirements,
                                    url: item?.url,
                                    requiredGenders: item.requiredGenders,
                                    requiredEthnicities: item.requiredEthnicities,
                                    competition: item.competition,
                                    gpaRequirementLowerBound: item.gpaRequirementLowerBound,
                                    gpaRequirementUpperBound: item.gpaRequirementUpperBound,
                                    ageRequirementLowerBound: item.ageRequirementLowerBound,
                                    ageRequirementUpperBound: item.ageRequirementUpperBound,
                                    usCitizenshipRequired: item.usCitizenshipRequired,
                                    letterofrecommendationRequired: item.letterofrecommendationRequired,
                                    essayRequirements: item.essayRequirements,
                                    additionalapplicationpaperworkRequired: item.additionalapplicationpaperworkRequired,
                                    scholarshipId: item?.scholarshipId
                                };

                                return scholarshipObject;
                            }
                        );
                        setScholarshipsListData(mappedScholarships || []);
                        setIsLoading(false);
                    } else {
                        setScholarshipsListData([]);
                        setIsLoading(false);
                        setRowCountState(0);
                        setTotalRecordCount(0);
                    }
                } else {
                    setScholarshipsListData([]);
                    setTotalRecordCount(0);
                    setRowCountState(0);
                    setIsLoading(false);
                }
            } catch (error) {
                setScholarshipsListData([]);
                setTotalRecordCount(0);
                setRowCountState(0);
                setIsLoading(false);
            }
        };
        fetchEmbeddedScholarshipsListData();
    }, [sortingOrder, searchTextFinal, paginationModel]);

    useEffect(() => {
        const fetchOrganizationBrandingDetails = async () => {
            try {
                let paramsBody;
                if (isId) {
                    paramsBody = {
                        organizationId: queryingParameter,
                    }
                }
                else {
                    paramsBody = {
                        dashedOrganizationName: queryingParameter
                    }
                }
                const res = await axios.get(`${getCounselorOrganizationsBrandingURL}`, {
                    headers: {},
                    params: paramsBody
                });
                if (res && res.data.code === 200) {
                    setOrganizationBrandingDetails(res.data.data[0] || {});
                    setOrganizationId(res.data.data[0]?.id);
                } else {
                    setOrganizationBrandingDetails({});
                }
            } catch (error) {
                setOrganizationBrandingDetails({});
            }
        };
        fetchOrganizationBrandingDetails();
    }, [queryingParameter]);

    const handleViewScholarship = (scholarshipId: number, dashedScholarshipName: string, scholarshipUrl: string, applyable: boolean) => {
        window.open(`/scholarships/${dashedScholarshipName}/${scholarshipId}`, '_blank');
    };

    useEffect(() => {
        const handleResize = () => {
            setTotalWidth(0.79 * window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const DetailsButton = styled(Box)(({ theme }) => ({
        marginBottom: '4px',
        color: COLOR_TEXT,
        backgroundColor: '#ECECEC',
        padding: '5.888px 8.833px',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '125%',
        fontFamily: 'Poppins',
        borderRadius: '4px',
    }));

    const columnWidths = {
        title: 0.25,
        requirement: 0.4,
        deadline: 0.18,
        amount: 0.1,
    };

    const columns = [
        {
            field: 'title',
            headerName: 'Scholarship',
            headerClassName: 'header-gray',
            disableColumnMenu: true,
            flex: 1,
            minWidth: columnWidths.title * totalWidth,
            maxWidth: columnWidths.title * totalWidth,
            renderCell: (params: any) => {
                const scholarshipData = params.row;
                const title = scholarshipData?.title ? scholarshipData?.title : scholarshipData?.name;
                const titleInLowerCase = title.toLowerCase();
                const dashedScholarshipName = titleInLowerCase.replace(/[,./?]|\s+/g, (match) => match === ',' || match === '.' || match === '?' || match === '/' ? '' : '-');
                const applyable = scholarshipData?.applyable;
                const scholarshipId = scholarshipData?.scholarshipId;
                const scholarshipUrl = scholarshipData?.url || '';
                return (
                    <Box style={{ display: 'flex', flexDirection: 'column', gap: '5%', textAlign: 'left' }}>
                        <Link
                            to={`/scholarships/${dashedScholarshipName}/${scholarshipId}`}
                            style={{ textDecoration: 'none' }}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                            <Typography
                                id="dashboard-header-title-text"
                                style={{
                                    textAlign: 'left',
                                    fontFamily: 'Poppins',
                                    color:
                                        isHovered && hoveredId === scholarshipId
                                            ? isColor(organizationBrandingDetails?.otherHighlightColor) ?
                                                organizationBrandingDetails?.otherHighlightColor : '#212529'
                                            : '#212529',
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    width: '100%',
                                    cursor: 'pointer',
                                    whiteSpace: 'normal',
                                }}
                                onClick={() => handleViewScholarship(scholarshipId, dashedScholarshipName, scholarshipUrl, applyable)}
                                onMouseEnter={() => handleMouseEnter(scholarshipId)}
                                onMouseLeave={handleMouseLeave}
                                key={scholarshipId}
                            >
                                {title}
                            </Typography>
                        </Link>
                        {applyable === true ? (
                            <Box
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    gap: '4px',
                                    border: '1px solid #ececec', padding: '1px 4px', backgroundColor: '#fff', borderRadius: '4px', width: 'fit-content'
                                }}>
                                <img
                                    src={oneClickApplySvg}
                                    alt="apply button"
                                    style={{ width: '14px', height: '14px' }}
                                />
                                <Typography className="one-click-apply-text" sx={{fontSize: '10px'}}>ONE CLICK APPLY</Typography>
                            </Box>
                        ) : (
                            <></>
                        )}
                    </Box>
                );
            },
        },
        {
            field: 'requirements',
            headerName: 'Requirement',
            headerClassName: 'header-gray',
            disableColumnMenu: true,
            flex: 1,
            minWidth: columnWidths.requirement * totalWidth,
            // maxWidth: columnWidths.requirement * totalWidth,
            sortable: false,
            renderCell: (params: any) => {
                const scholarshipData = params.row;
                const requirementArray = scholarshipData.requirements;
                const moreDetailsArray = scholarshipData.moreDetails;
                const hasMoreQualifications = scholarshipData.hasMoreQualifications;
                const hasMoreRequirements = scholarshipData.hasMoreRequirements;
                const moreRequirements = scholarshipData.moreRequirements;
                const moreQualifications = scholarshipData.moreQualifications;
                const isAnyMoreDetailsRequirementTrue = moreDetailsArray.some((req) => req.value === true);
                const requiredGenders = scholarshipData.requiredGenders;
                const requiredEthnicities = scholarshipData.requiredEthnicities;
                const gpaRequirementLowerBound = scholarshipData.gpaRequirementLowerBound;
                const gpaRequirementUpperBound = scholarshipData.gpaRequirementUpperBound;
                const ageRequirementLowerBound = scholarshipData.ageRequirementLowerBound;
                const ageRequirementUpperBound = scholarshipData.ageRequirementUpperBound;
                const usCitizenshipRequired = scholarshipData.usCitizenshipRequired;
                const letterofrecommendationRequired = scholarshipData.letterofrecommendationRequired;
                const essayRequirements = scholarshipData.essayRequirements;
                const additionalapplicationpaperworkRequired = scholarshipData.additionalapplicationpaperworkRequired;
                const competition = scholarshipData.competition;
                return (
                    <Box style={{ display: 'flex', flexWrap: 'wrap', width: '100%', gap: '1%' }}>
                        {requirementArray &&
                            requirementArray.map((requirement: any, index: number) => {
                                if (requirement.value === true) {
                                    return <DetailsButton key={index}>{requirement.name}</DetailsButton>;
                                }
                            })}
                        {isAnyMoreDetailsRequirementTrue && (
                            <Tooltip
                                title={
                                    <Grid container>
                                        {hasMoreQualifications && !hasMoreRequirements && (
                                            <Grid item xs={12}>
                                                <Box>
                                                    <span style={{ color: 'black' }}>Qualifications</span>
                                                    <Divider />
                                                    <Box>
                                                        <span style={{ color: '#838383' }}>
                                                            {moreQualifications}
                                                        </span>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        )}
                                        {hasMoreRequirements && !hasMoreQualifications && (
                                            <Grid item xs={12}>
                                                <Box>
                                                    <span style={{ color: 'black' }}>Requirements</span>
                                                    <Divider />
                                                    <Box>
                                                        <span style={{ color: '#838383' }}>{moreRequirements}</span>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        )}
                                        {hasMoreRequirements && hasMoreQualifications && (
                                            <Grid container>
                                                <Grid item xs={5.9}>
                                                    <Box>
                                                        <span style={{ color: 'black' }}>Requirements</span>
                                                        <Divider />
                                                        <Box>
                                                            <span style={{ color: '#838383' }}>
                                                                {moreRequirements}
                                                            </span>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                                <Divider orientation="vertical" />
                                                <Grid item xs={5.9}>
                                                    <Box>
                                                        <span style={{ color: 'black' }}>Qualifications</span>
                                                        <Divider />
                                                        <Box>
                                                            <span>{moreQualifications}</span>
                                                        </Box>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                }
                                PopperProps={{
                                    sx: {
                                        '& .MuiTooltip-tooltip': {
                                            backgroundColor: '#FFF',
                                            color: '#838383',
                                            fontFamily: 'Poppins',
                                            boxShadow: '3px  #838383',
                                            border: '1px solid #ECECEC',
                                        },
                                    },
                                }}
                                TransitionProps={{ timeout: 0 }}>
                                <button
                                    style={{
                                        marginBottom: '4px',
                                        color: organizationBrandingDetails?.customBranding && isColor(organizationBrandingDetails?.otherHighlightTextColor) ? organizationBrandingDetails?.otherHighlightTextColor || '#FFF' : '#FFF',
                                        backgroundColor: organizationBrandingDetails?.customBranding && isColor(organizationBrandingDetails?.otherHighlightTextColor) ? organizationBrandingDetails?.otherHighlightColor || '#F7941D' : '#F7941D',
                                        padding: '5.888px 8.833px',
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        lineHeight: '125%',
                                        fontFamily: 'Poppins'
                                    }}>
                                    More Details
                                </button>
                            </Tooltip>
                        )}
                        {requiredGenders &&
                            requiredGenders.map((gender: any, index: number) => (
                                <DetailsButton key={index}>{gender?.title}</DetailsButton>
                            ))}
                        {requiredEthnicities &&
                            requiredEthnicities.map((ethnicity: any, index: number) => (
                                <DetailsButton key={index}>{ethnicity?.title}</DetailsButton>
                            ))}
                        {gpaRequirementLowerBound != null && gpaRequirementUpperBound != null && (
                            <DetailsButton>
                                GPA {gpaRequirementLowerBound} - {gpaRequirementUpperBound}
                            </DetailsButton>
                        )}
                        {gpaRequirementLowerBound != null && gpaRequirementUpperBound == null && (
                            <DetailsButton>GPA {gpaRequirementLowerBound} +</DetailsButton>
                        )}
                        {ageRequirementLowerBound != null && ageRequirementUpperBound != null && (
                            <DetailsButton>
                                Age {ageRequirementLowerBound} - {ageRequirementUpperBound}
                            </DetailsButton>
                        )}
                        {ageRequirementLowerBound != null && ageRequirementUpperBound == null && (
                            <DetailsButton>Age {ageRequirementLowerBound} +</DetailsButton>
                        )}

                        {/* These commented sections are already available on above requirementArray.So,for temporary purspose they are commented! */}
                        {/* {usCitizenshipRequired && <DetailsButton>US Citizen</DetailsButton>} */}
                        {/* {letterofrecommendationRequired && <DetailsButton>Rec. Letter</DetailsButton>} */}
                        {essayRequirements && <DetailsButton>Essay</DetailsButton>}
                        {/* {additionalapplicationpaperworkRequired && <DetailsButton>Paper App.</DetailsButton>} */}
                        {competition >= 66 && !hasMoreQualifications && !hasMoreQualifications && (
                            <Tooltip
                                title={
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Box>
                                                <span style={{ color: '#838383' }}>
                                                    You're 100% qualified for this scholarship.
                                                </span>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                }
                                PopperProps={{
                                    sx: {
                                        '& .MuiTooltip-tooltip': {
                                            backgroundColor: '#FFF',
                                            color: '#838383',
                                            fontFamily: 'Poppins',
                                            boxShadow: '3px  #838383',
                                            border: '1px solid #ECECEC',
                                        },
                                    },
                                }}
                                TransitionProps={{ timeout: 0 }}>
                                <DetailsButton>100%</DetailsButton>
                            </Tooltip>
                        )}
                    </Box>
                );
            },
        },
        {
            field: 'deadline',
            headerName: 'Application Deadline',
            headerClassName: 'header-gray',
            disableColumnMenu: true,
            flex: 1,
            minWidth: columnWidths.deadline * totalWidth,
            maxWidth: columnWidths.deadline * totalWidth,
            renderCell: (params: any) => {
                const scholarship = params.row;
                const deadline = scholarship?.deadline;
                const currentDateUTC = new Date(
                    Date.UTC(
                        new Date().getUTCFullYear(),
                        new Date().getUTCMonth(),
                        new Date().getUTCDate(),
                        new Date().getUTCHours(),
                        new Date().getUTCMinutes(),
                        new Date().getUTCSeconds(),
                        new Date().getUTCMilliseconds()
                    )
                );
                if (deadline) {
                    const date = new Date(deadline);
                    const isExpired = currentDateUTC > date;
                    const year = date.getFullYear().toString();
                    const month = (date.getMonth() + 1).toString().padStart(2, '0');
                    const day = date.getDate().toString().padStart(2, '0');
                    const deadlineString = `${month}/${day}/${year}`;


                    return (
                        <div className="scholarship-table">
                            {isExpired && (
                                <div id="scholarship-expired-status">
                                    <p id="expired-status-text">
                                        <Box id="expired-img" />
                                        &nbsp;Expired
                                    </p>
                                </div>
                            )}
                            <p 
                                style={{
                                    fontFamily: 'Poppins',
                                    fontSize: '14px',
                                    color: '#212529',
                                    fontWeight: 500,
                                    textAlign: 'right',
                                    margin: 'auto 0px'
                                }}
                            >{deadlineString}</p>
                        </div>
                    );
                } else {
                    return <></>;
                }
            },
        },
        {
            field: 'amount',
            headerName: 'Amount',
            headerClassName: 'header-gray',
            disableColumnMenu: true,
            flex: 1,
            minWidth: columnWidths.amount * totalWidth,
            maxWidth: columnWidths.amount * totalWidth,
            renderCell: (params: any) => {
                const scholarshipData = params.row;
                const scholarshipAmount = scholarshipData?.amount?.toLocaleString();
                return (
                    <span
                        style={{
                            fontSize: '14px',
                            color: '#212529',
                            fontWeight: 500,
                            fontFamily: 'Poppins',
                        }}>
                        ${scholarshipAmount}
                    </span>
                );
            },
        },
    ];

    const returnNonProfitOrganizationLogoURL = (id: number) => {
        return `${getNonProfitOrganizationLogoURL(id)}`;
    };

    const handleImageError = (event) => {
        event.target.onError = null;
        event.target.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    };

    const matchesTab = useMediaQuery('(max-width:1000px)');

    useEffect(() => {
        const reprisedOrganizaitonScholarshipHeader = async () => {
            if (organizationBrandingDetails) {
                const originalNameAddress = organizationBrandingDetails?.name;

                if (typeof (originalNameAddress) === 'undefined') {
                    try {
                        const res = await axios.get(`${getCounselorOrganizationDetailsURL(organizationId)}`, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });
                        if (res && res.data.code === 200) {
                            setOrganizationDetails(res.data.data);
                            if (res.data.data.name !== '') {
                                const orgName = res.data.data.name || 'ScholarBox';
                                const nameInLowerCase = orgName?.toLowerCase();
                                const dashedName = nameInLowerCase.replace(/,|\s+/g, (match) => match === ',' ? '' : '-');
                                setDashedNameAddress(dashedName);
                                const originalName = orgName?.split(',')[0] || 'Scholar Box';
                                const splittedNameParts = originalName?.split(' ');
                                let firstLetterCapCasedNameparts = splittedNameParts?.map((word) => {

                                    const a = word.split('');
                                    if (a.some((item) => item == '-')) {
                                        const dash = word?.split('-');
                                        if (dash?.length > 1) {
                                            const convertIntoCamelCase = dash.map((parts) => {
                                                return parts[0].toUpperCase() + parts.slice(1).toLowerCase();
                                            })
                                            const newWord = convertIntoCamelCase?.join('-');
                                            return newWord;
                                        }
                                    }
                                    return word[0].toUpperCase() + word.slice(1).toLowerCase();
                                });

                                // const originalName = orgName?.split(',')[0];
                                // const splittedNameParts = originalName?.split(' ');
                                // let firstLetterCapCasedNameparts = splittedNameParts?.map((word) => {
                                //     return word[0].toUpperCase() + word.slice(1).toLowerCase();
                                // });
                                setFirstLetterCappedName(firstLetterCapCasedNameparts?.join(' '))
                                setFirstLetterCapCasedName(firstLetterCapCasedNameparts?.join(' ') + ' ' + 'Scholarships');
                                document.title = `${res.data.data.name} | Scholar Box`
                            }
                            const attachmentArray = res.data.data.organizationsAttachments || [];
                            const logoData = attachmentArray.find((item) => item?.attachmentType?.id === 1);
                            const logoAttachmentId = logoData?.attachment?.s3Url;
                            setOrganizationLogoUrl(logoAttachmentId);
                        } else {
                            setFirstLetterCappedName('ScholarBox');
                            setFirstLetterCapCasedName('ScholarBox Scholarships');
                            setDashedNameAddress('scholarbox-scholarships');
                        }
                    } catch (error) {
                        const payload = {
                            source: 'React Js Application',
                            logText: `${error}`,
                        };
                        await axios.post(getLoggersURL, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        });
                        throw error;
                    }
                } else {
                    const originalName = originalNameAddress?.split(',')[0] || 'Scholar Box';
                    const nameInLowerCase = originalNameAddress?.toLowerCase();
                    const dashedName = nameInLowerCase.replace(/,|\s+/g, (match) => match === ',' ? '' : '-');
                    setDashedNameAddress(dashedName);
                    const splittedNameParts = originalName?.split(' ');
                    let firstLetterCapCasedNameparts = splittedNameParts?.map((word) => {

                        const a = word.split('');
                        if (a.some((item) => item == '-')) {
                            const dash = word?.split('-');
                            if (dash?.length > 1) {
                                const convertIntoCamelCase = dash.map((parts) => {
                                    return parts[0].toUpperCase() + parts.slice(1).toLowerCase();
                                })
                                const newWord = convertIntoCamelCase?.join('-');
                                return newWord;
                            }
                        }
                        return word[0].toUpperCase() + word.slice(1).toLowerCase();
                    });
                    setFirstLetterCappedName(firstLetterCapCasedNameparts?.join(' '))
                    setFirstLetterCapCasedName(firstLetterCapCasedNameparts?.join(' ') + ' ' + 'Scholarships');
                    document.title = `${originalNameAddress} | Scholar Box`
                }
            };
        }
        reprisedOrganizaitonScholarshipHeader();
    }, [organizationBrandingDetails?.name]);

    useEffect(() => {
        const date = new Date();
        let reprisedFavIconS3Url = "";
        if (organizationDetails) {
            const favIconData = organizationDetails?.organizationsAttachments?.find((items) => items.attachmentType.id === 2);
            const favIconUrl = favIconData?.attachmet?.s3Url;
            reprisedFavIconS3Url = `${AMAZON_S3_BASE_URL}` + `${favIconUrl}` + `?date=${date}`;
        } else {
            if (organizationBrandingDetails) {
                const favIconUrl = organizationBrandingDetails?.favIconS3Url;
                reprisedFavIconS3Url = `${AMAZON_S3_BASE_URL}` + `${favIconUrl}` + `?date=${date}`;
            }
        }
        if (reprisedFavIconS3Url !== `${AMAZON_S3_BASE_URL}null`) {
            const head = document.querySelector('head');
            const existingFavicon = head?.querySelector('link[rel="icon"]');
            if (existingFavicon) {
                head?.removeChild(existingFavicon);
            }
            const favIconLink = document.createElement('link');
            favIconLink.rel = 'icon';
            favIconLink.type = 'image/jpeg';
            favIconLink.href = reprisedFavIconS3Url;
            head?.appendChild(favIconLink);
            return () => {
                head?.removeChild(favIconLink);
            }


        }
        const resetFavicon = () => {
            const head = document.querySelector('head');
            const existingFavicon = head?.querySelector('link[rel="icon"]');
            if (existingFavicon) {
                head?.removeChild(existingFavicon);
            }
            const defaultFavicon = document.createElement('link');
            defaultFavicon.rel = 'icon';
            defaultFavicon.type = 'image/x-icon';
            defaultFavicon.href = '/favicon-16x16.png';
            head?.appendChild(defaultFavicon);
        }

        return () => {
            resetFavicon();
            document.title = "Scholar Box"
        }
    }, [organizationDetails, organizationBrandingDetails]);
    const date = new Date();

    return (



        <Box sx={{ background: '#ebebeb', height: organizationBrandingDetails === null ? '100vh' : '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
            {isProduction && (
                < HelmetHeader
                    title={`${firstLetterCapCasedName} | Scholar Box `}
                    description={`Find the best ${firstLetterCapCasedName} on Scholar Box. 
                    Scholarships for ${firstLetterCappedName} students—start applying and fund your future! `}
                    name='Scholarbox'
                    type='Organization'
                    keywords={`${firstLetterCapCasedName}, Scholar Box Scholarships, School Scholarships, College Scholarships`}
                    jsonLDs={[
                        {
                            "@context": "https://schema.org",
                            "@type": "Article",
                            "mainEntityOfPage": {
                                "@type": "WebPage",
                                "@id": `https://scholarbox.org/schools/${dashedNameAddress}/scholarships`
                            },
                            "headline": `${firstLetterCapCasedName}`,
                            "description": `This page consist of ${firstLetterCapCasedName} where high school seniors can easily apply for scholarships.`,
                            "image": `${AMAZON_S3_BASE_URL}` +
                                `${organizationBrandingDetails?.logoS3Url + `?date=${date}`
                                    ? organizationBrandingDetails?.logoS3Url + `?date=${date}`
                                    : organizationLogoUrl + `?date=${date}`
                                }`,
                            "author": {
                                "@type": "Organization",
                                "name": "Scholar Box",
                                "url": "https://scholarbox.org/"
                            },
                            "publisher": {
                                "@type": "Organization",
                                "name": "Scholar Box",
                                "logo": {
                                    "@type": "ImageObject",
                                    "url": "https://scholarbox.org/Scholar-Box-Logo.3a1c943a.png"
                                }
                            },
                            "datePublished": "2024-08-10",
                            "dateModified": "2024-09-26"
                        },
                        {
                            "@context": "https://schema.org/",
                            "@type": "WebSite",
                            "name": "Scholar Box",
                            "url": "https://scholarbox.org/",
                            "potentialAction": {
                                "@type": "SearchAction",
                                "target": `https://scholarbox.org/schools/${dashedNameAddress}/scholarships{search_term_string}`,
                                "query-input": "required name=search_term_string"
                            }
                        },
                        // {
                        //     "@context": "https://schema.org/",
                        //     "@type": "BreadcrumbList",
                        //     "itemListElement": [
                        //         {
                        //             "@type": "ListItem",
                        //             "position": 1,
                        //             "name": "Scholar Box Home Page",
                        //             "item": "https://scholarbox.org/"
                        //         },
                        //         {
                        //             "@type": "ListItem",
                        //             "position": 2,
                        //             "name": `${firstLetterCapCasedName}`,
                        //             "item": `https://scholarbox.org/schools/${dashedNameAddress}/scholarships`
                        //         }
                        //     ]
                        // },
                        {
                            "@context": "https://schema.org/",
                            "@type": "BreadcrumbList",
                            "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Scholar Box Home Page",
                                    "item": {
                                        "@type": "WebPage",
                                        "@id": "https://scholarbox.org/"
                                    }
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": `${firstLetterCapCasedName}`,
                                    "item": {
                                        "@type": "WebPage",
                                        "@id": `https://scholarbox.org/schools/${dashedNameAddress}/scholarships`
                                    }

                                }
                            ]
                        },
                    ]}
                />
            )}
            {organizationBrandingDetails !== null ? (
                <Box sx={{ border: 'solid #ebebeb' }}>
                    <Box
                        sx={{
                            background: 'white',
                            width: { xs: '96vw', sm: '96vw', md: '95vw', lg: '85vw', xl: '80vw' },
                            margin: { xs: '24px auto', sm: '32px auto', md: '48px auto 48px auto' },
                            borderRadius: '10px',
                            padding: { xs: '0px 20px 10px 20px', md: '20px' },
                        }}>
                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: { xs: '5px 0px 5px 0px', md: '5px 32px' },


                                    borderBottom: '2px solid #cccccc',
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        width: '100%',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexDirection: { xs: 'row', sm: 'row' },
                                        gap: '10px'
                                    }}>
                                    <HeaderText variant='h1' sx={{ margin: { xs: '8px 0px 8px 0px', md: '8px 0px 8px 0px' }, textAlign: { xs: 'left', sm: 'left' }, fontWeight: 700, color: COLOR_TEXT, fontSize: { xs: '24px', md: '32px' } }}>
                                        {firstLetterCapCasedName}
                                    </HeaderText>
                                    <Box
                                        sx={{
                                            width: { xs: 'auto', sm: 'auto', md: 'auto' },
                                            height: { xs: '68px', sm: '72px', md: '100px' },
                                        }}>
                                        {(organizationBrandingDetails?.logoS3Url || organizationLogoUrl) && (
                                            <img
                                                src={
                                                    `${AMAZON_S3_BASE_URL}` +
                                                    `${organizationBrandingDetails?.logoS3Url + `?date=${date}`
                                                        ? organizationBrandingDetails?.logoS3Url + `?date=${date}`
                                                        : organizationLogoUrl + `?date=${date}`
                                                    }`
                                                }
                                                style={{ width: 'auto', height: '100%' }}
                                                onError={handleImageError}
                                                alt={`${firstLetterCapCasedName} Logo`}
                                            />
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                            <Box
                                sx={{
                                    justifyContent: 'flex-start',
                                    padding: '2px 0',
                                    display: 'flex',
                                    gap: '12px',
                                    flexWrap: 'wrap',
                                    m: { xs: '24px 0' },
                                    flexDirection: {xs: 'column', md: 'row'},
                                    alignItems: 'center'
                                }}>
                                <Box
                                    sx={{
                                        width: { xs: '100%', sm: '60%', md: '350px' },
                                        borderRadius: '7.64px',
                                    }}>
                                    <SearchOption
                                        bgColor="#F6F6F6"
                                        handleChange={handleSearchTextChange}
                                        handleSearch={handleSearch}
                                    />
                                </Box>

                                <CustomActionButton
                                    href="/scholarships"
                                    buttonText="View all scholarships"
                                    // endAdornment={<ArrowForwardIosIcon sx={{fontSize: '14px', color: organizationBrandingDetails?.customBranding && isColor(organizationBrandingDetails?.otherHighlightTextColor) ? organizationBrandingDetails?.otherHighlightTextColor || COLOR_WHITE : COLOR_WHITE, height: '100%'}}/>}
                                    styleProps={{
                                        backgroundColor: organizationBrandingDetails?.customBranding && isColor(organizationBrandingDetails?.otherHighlightColor) ? organizationBrandingDetails?.otherHighlightColor || COLOR_SECONDARY : COLOR_SECONDARY,
                                        color: organizationBrandingDetails?.customBranding && isColor(organizationBrandingDetails?.otherHighlightTextColor) ? organizationBrandingDetails?.otherHighlightTextColor || COLOR_WHITE : COLOR_WHITE,
                                        '&:hover': {
                                            backgroundColor: organizationBrandingDetails?.customBranding && isColor(organizationBrandingDetails?.otherHighlightColor) ? organizationBrandingDetails?.otherHighlightColor || COLOR_SECONDARY : COLOR_SECONDARY,
                                            color: organizationBrandingDetails?.customBranding && isColor(organizationBrandingDetails?.otherHighlightTextColor) ? organizationBrandingDetails?.otherHighlightTextColor || COLOR_WHITE : COLOR_WHITE,
                                        },
                                    }}
                                />
                            </Box>
                            {matchesTab && isLoading === false && (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: { xs: '16px', sm: '10px', md: '16px' },
                                        mb: '16px',
                                        justifyContent: { xs: 'center', sm: 'space-between' },
                                    }}
                                    display="flex"
                                    width="100%">
                                    {scholarshipsListData?.map((item, idx) => (
                                        <DashboardSchoarshipCard
                                            styleProps={{ width: '49%' }}
                                            usedTab="embeddedSholarship"
                                            key={idx}
                                            item={item}
                                            showDeadline={true}
                                            showCompetition={false}
                                            handleViewEmbeddedScholarship={handleViewScholarship}
                                            brandingBgColor={organizationBrandingDetails.customBranding && isColor(organizationBrandingDetails?.otherHighlightTextColor) ? organizationBrandingDetails?.otherHighlightColor : '#F7941D'}
                                        />
                                    ))}
                                </Box>
                            )}
                            <Box>
                                {scholarshipsListData ? (
                                    <CssDataGrid
                                        key={`table-${paginationModel.page}`}
                                        columns={columns}
                                        rows={scholarshipsListData}
                                        getRowHeight={() => 'auto'}
                                        getRowClassName={(params) =>
                                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'embed-row-odd'
                                        }
                                        getRowId={(row) => row.rowIndex}
                                        initialState={{
                                            sorting: {
                                                sortModel: [
                                                    { field: 'title', sort: 'asc' },
                                                    { field: 'requirements', sort: 'asc' },
                                                    { field: 'deadline', sort: 'asc' },
                                                    { field: 'amount', sort: 'asc' },
                                                ],
                                            },
                                            pagination: { paginationModel: { pageSize: 10 } },
                                        }}
                                        sx={{
                                            width: '100%',
                                            '& .MuiDataGrid-main': {
                                                display: 'block',
                                                '@media(max-width: 1000px)': {
                                                    display: 'none',
                                                },
                                            },
                                            '& .MuiDataGrid-columnHeaders': {
                                                height: TABLE_HEADER_HEIGHT,
                                                minHeight: `${TABLE_HEADER_HEIGHT}!important`,
                                            },
                                            '& .MuiDataGrid-columnHeaderTitle': {
                                                textTransform: HEADER_TEXT_TRANSFORM,
                                                color: '#212529',
                                            },
                                            '& .MuiDataGrid-footerContainer': {
                                                minHeight: TABLE_FOOTER_HEIGHT,
                                                height: TABLE_FOOTER_HEIGHT,
                                                '@media(max-width: 1000px)': {
                                                    minHeight: TABLE_FOOTER_HEIGHT_SMALL,
                                                    height: TABLE_FOOTER_HEIGHT_SMALL,
                                                },
                                            },
                                            '& .MuiTablePagination-displayedRows': {
                                                margin: TABLE_PAGINATION_MARGIN,
                                            },
                                            '& .MuiDataGrid-cell': {
                                                padding: '8px 10px 4px 10px',
                                            },

                                            '& .MuiTablePagination-actions button': {
                                                // Apply custom styles to the next and previous buttons
                                                '&.MuiIconButton-root': {
                                                    backgroundColor: `${organizationBrandingDetails?.customBranding ? isColor(organizationBrandingDetails?.navBackgroundColor) ? organizationBrandingDetails?.navBackgroundColor : '#FFF' : '#FFF'}`,
                                                    color: `${organizationBrandingDetails?.customBranding ? isColor(organizationBrandingDetails?.navBackgroundColor) ? '#FFF' : '#000' : '#000'}`,
                                                    borderRadius: '0px',
                                                    padding: '0px',
                                                    marginRight: '2px',

                                                    '&.Mui-disabled': {
                                                        // Define styles for disabled buttons if needed
                                                        // backgroundColor:'white',
                                                        backgroundColor: `${organizationBrandingDetails?.customBranding && isColor(organizationBrandingDetails?.navBackgroundColor) ? lightenColor(organizationBrandingDetails?.navBackgroundColor) : '#FFF'}`,
                                                    },
                                                },
                                            },
                                        }}
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={setPaginationModel}
                                        pageSizeOptions={[10]}
                                        rowCount={rowCountState}
                                        onColumnHeaderClick={handleColumnHeaderClick}
                                        sortingMode="server"
                                        paginationMode="server"
                                        pagination
                                        slots={{
                                            noRowsOverlay:
                                                scholarshipsListData?.length === 0 ? CustomNoRowsOverlay : undefined,
                                        }}
                                        autoHeight
                                        organizationBrandingDetails={organizationBrandingDetails}
                                        loading={isLoading}
                                    />
                                ) : null}
                                {!scholarshipsListData && isLoading && (
                                    <CircularProgress
                                        sx={{ color: 'orange', alignSelf: 'center', marginLeft: '45%', my: 5 }}
                                    />
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ) : (
                <CircularProgress sx={{ alignSelf: 'center', justifyContent: 'center' }} />
            )}
            <ScholarshipPage />
        </Box>
    );
};

export default EmbeddedScholarhips;
